<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="dashboard-component-wrapper">
  <div class="header-wrapper">
    <span class="component-label draggable">{{title}}</span>
    <span *ngIf="routeLink"
          [routerLink]="[routeLink]"
          [queryParams]="routeQueryParams"
          class="mdi mdi-open-in-new always-open-icon link">
        </span>
  </div>
  <div *ngIf="!loading; else skeletonLoader" id="total-{{title}}" class="item-value"
       attr.aria-label="Total {{title}}">{{total | number: '1.0-0'}}</div>
  <ng-template #skeletonLoader>
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
          display: 'flex',
          height: '32px',
          width: '80px',
          margin: '28px auto 12px auto',
        }">
    </ngx-skeleton-loader>
  </ng-template>
</div>

